import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { from as fromPromise, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { OrderFormRecord, orderFormRecordDecoder } from '@trade-platform/ui-shared';

@Injectable()
export class OrderFormService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    getOrderForm(orderId: string, formId: string): Observable<OrderFormRecord> {
        return this.http
            .get<OrderFormRecord>(`${this.environment.api}orders/${orderId}/forms/${formId}`)
            .pipe(concatMap(p => fromPromise(orderFormRecordDecoder.decodeToPromise(p))));
    }
}
